import React from 'react';
import { faqContent } from '@/content/faq';
import FaqQuestion from './FaqQuestion';
import { Section } from '@/components/ui';

/**
 * Visible, plain-language FAQ section. Doubles as the on-page source for the
 * `FAQPage` JSON-LD rendered by `<Seo faq={faqContent.items} />` on the home
 * page (see `src/pages/Home.tsx`) — keeping both in sync so structured data
 * always matches what a visitor (and an AI crawler) actually reads.
 */
const Faq: React.FC = () => {
    return (
        <Section id="faq" className="faq" title={faqContent.sectionTitle}>
            <div className="faq-list">
                {faqContent.items.map((item) => (
                    <FaqQuestion key={item.question} {...item} />
                ))}
            </div>
        </Section>
    );
};

export default Faq;
